import api from '@services/api';
import {
  InitializeKyxActionRequestDto,
  UpdateKyxActionRequestDto,
  VerificationApi,
  VerificationTierStatus,
  VerifyActionStatusDto,
} from '@services/generated';
import { handleErrors } from '@services/helpers';
import { rootApi } from '@store/root-api';
import appHelpers from '@utils/app-urls';

const API_URL = appHelpers.getEndpointUrl();

const verificationClient = new VerificationApi(
  undefined,
  new URL(API_URL, process.env.REACT_API_URL).href,
  api,
);

interface SumSubState {
  sdkToken: string;
  timestamp: string;
  idUserIdAction: string;
}

export const verificationApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    getSumsubToken: builder.query<SumSubState, InitializeKyxActionRequestDto>({
      queryFn: async data => {
        const res = await handleErrors(() =>
          verificationClient.initializeOrGetIdUserActionV2(data),
        );
        if (res.error) return res;

        const sumSubState = {
          sdkToken: res.data.fields.sdkToken,
          timestamp: res.data.fields.timestamp,
          idUserIdAction: res.data.idUserActionId,
        };

        return { data: sumSubState, error: undefined, meta: res.meta };
      },
    }),
    getVerificationStatus: builder.query<
      VerificationTierStatus, void
    >({
      queryFn: data =>
        handleErrors(() =>
          verificationClient.tierStatus(),
        ),
    }),
    updateUserAction: builder.mutation<
      VerifyActionStatusDto[],
      UpdateKyxActionRequestDto
    >({
      queryFn: data =>
        handleErrors(() =>
          verificationClient.updateIdUserActionReference(data),
        ),
    }),
  }),
});

export const { useGetSumsubTokenQuery, useUpdateUserActionMutation,  } =
  verificationApi;
